import { INSTANCE_STATE_LIST,STATUS_STATE_LIST,activeStateInstructions } from "../../../../utils/configs";
import { FaLock } from "react-icons/fa6";
import { SlCalender } from "react-icons/sl";
import { BsLightningFill } from "react-icons/bs";
import { IoMdCheckboxOutline } from "react-icons/io";
import { IoFlask } from "react-icons/io5";
import { BsFillFlagFill } from "react-icons/bs";
import { ImBlocked } from "react-icons/im";
import { FaExclamation } from "react-icons/fa";
import { copyToClipBoard } from "../../../../utils/commonFunctions";

const getOrderStatusColorCode = (params) => {

  if (params) {
    const {field}=params.colDef;
if(field==='state'){
   const stateIns = params.data?.state;
    const ordSts = INSTANCE_STATE_LIST.find( _ => _.key === stateIns );
    if (ordSts) {
      return (
        <div  className="flexRow alignItemsCenter">
          { ordSts.value === 'Active' && <BsLightningFill  color={ ordSts.colorCode_text } size={15}/> }
          { ordSts.value === 'Locked' && <FaLock color={ ordSts.colorCode_text } size={15}/> }
          { ordSts.value === 'Committed' && <IoMdCheckboxOutline color={ ordSts.colorCode_text } size={15}/> }
          { ordSts.value === 'Commit Scheduled' && <SlCalender color={ ordSts.colorCode_text } size={15}/> }
          &nbsp;&nbsp;<span title={ordSts.value === "Active" ? activeStateInstructions:""} aria-label={ordSts.value === "Active" ? activeStateInstructions:""}>{ordSts.value}</span>
        </div>
      );
    }
    else {
      return <>{ordSts}</>
    }
}else{
  const statusIns = params.data?.status;
    const ordSts = STATUS_STATE_LIST.find( _ => _.key === statusIns );
    if (ordSts) {
      return (
        <div className="flexRow alignItemsCenter">
          { ordSts.key === 'confirmed' && <BsFillFlagFill  color={ ordSts.colorCode_text } size={15}/> }
          { ordSts.key === 'created' && <IoFlask color={ ordSts.colorCode_text } size={15}/> }
          { ordSts.key === 'completed' && <IoMdCheckboxOutline color={ ordSts.colorCode_text } size={15}/> }
          { ordSts.key === 'cancelled' && <ImBlocked color={ ordSts.colorCode_text } size={15}/> }
          &nbsp;&nbsp;<span>{ordSts.label}</span>
        </div>
      );
    }
    else {
      return <>{ordSts}</>
    }
}

  }
  return null;
}

export const InstanceStates = (props) => {


    let iconL = props.data ? getOrderStatusColorCode(props) : null;

    return (
        <div className="orderStatus-renderer">
            {iconL}
        </div>
    );
};

export const InstanceName = (props) => {
    return (
        <div style={{cursor:"pointer"}} title="Click to copy!" onClick={e=>copyToClipBoard(e,props.data?.name)} className="orderStatus-renderer">
            {props.data?.name}
        </div>
    );
};

export const InstanceKeyWithWarning = ({ data }) => {
  if (!data) return null;

  const shouldShowWarning = !data.layout?.length;

  return (
    <div className="orderStatus-renderer">
      {shouldShowWarning ? (
        <span title="No layout added">
          <FaExclamation style={{ color: '#d9534f', marginRight: '4px' }} />
          {data.key}
        </span>
      ) : (
        <div className="margLeft9">
       { data.key}
        </div>
      )}
    </div>
  );
};
